/*********************************************************/
/*** overwrites theme js | Latori GmbH www.latori.com ***/
/*********************************************************/

if (!Array.prototype.filter) {
  Array.prototype.filter = function(func, thisArg) {
    'use strict';
    if ( ! ((typeof func === 'Function' || typeof func === 'function') && this) )
        throw new TypeError();
    
    var len = this.length >>> 0,
        res = new Array(len), // preallocate array
        t = this, c = 0, i = -1;
    if (thisArg === undefined) {
      while (++i !== len){
        // checks to see if the key was set
        if (i in this){
          if (func(t[i], i, t)){
            res[c++] = t[i];
          }
        }
      }
    }
    else{
      while (++i !== len){
        // checks to see if the key was set
        if (i in this){
          if (func.call(thisArg, t[i], i, t)){
            res[c++] = t[i];
          }
        }
      }
    }
    
    res.length = c; // shrink down array to proper size
    return res;
  };
}

String.prototype.imgURL = function(size) {
  // remove any current image size then add the new image size
  return this
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
  // example 
  // '//cdn.shopify.com/s/files/1/0087/0462/products/shirt14.jpeg?v=1309278311'.imgURL('medium');
  // outputs
  // '//cdn.shopify.com/s/files/1/0087/0462/products/shirt14_medium.jpeg?v=1309278311'
};

var SCHMUCK_ART_ID_RINGE = 8;

var cart = class {
  constructor($section) {
    this.$section = $section;
    this.$inputCode = this.$section.find('input[name="discount"]');
  }
  init() {
    var _this = this;
    this.$inputCode.on("input change", function () {
      var discount = $(this).val().toUpperCase();
      var code = _this.findCode(discount);
      if (code) {
        // _this.enableAddProduct(code.variantId);
        $(this).attr('disabled', true);
        $(this).after('Code ok');
        if (!code.inCart) {
          _this.addProduct(code.variantId);
        }
        $('.proceed a').attr('href', $('.proceed a').attr('href')+'?discount='+code.code);
      } else {
        _this.disableAllAddProduct();
      }
    });
  }
  findCode(code) {
    return window.CHECKOUT_CODES.find(function(CHECKOUT_CODES) {
        return CHECKOUT_CODES && CHECKOUT_CODES.code && CHECKOUT_CODES.code == code;
    });
  }
  addProduct(variantId) {
    $.post('/cart/add.js', {
      items: [
        {
          quantity: 1,
          id: variantId
        }
      ]
    });
  }
  disableAllAddProduct() {
    $( "input[id^='variant_']" ).prop("disabled", true);
  }
  disableAddProduct(variantId) {
    $("#variant_"+variantId).prop("disabled", true);
  }
  enableAddProduct(variantId) {
    $("#variant_"+variantId).prop("disabled", false);
  }
}

var pdp = class {
  constructor($section) {
    this.$section = $section;
    this.$ajaxColorSwatch = $('[data-ajax-color-swatch]');
    this.$productcode = {};
    if (this.$ajaxColorSwatch.length > 0) {
      this.$productcode = this.$ajaxColorSwatch.data().productcode;
      this.$producttype = this.$ajaxColorSwatch.data().producttype;
      this.selectedVariantId = this.$ajaxColorSwatch.data().selectedVariantId;
    }
   
    this.$colorSwatch = this.$section.find('.color-swatch');
  }
  init() {
    if (this.$ajaxColorSwatch.length > 0) {
      this.fetchColorChange();
    }
  }
  handleColorHover() {

    let imagesHover = document.querySelectorAll("[data-ajax-color-swatch] a img");
    if (imagesHover.length > 0) {
    
      for (let i = 0; i < imagesHover.length;i++){
        let item = imagesHover[i];
        
        item.addEventListener("mouseover", function (e) {

          if (e.target && e.target.getAttribute("data-origin-image") && e.target.getAttribute("data-origin-image") !== "") {
            let hoverSrc = e.target.getAttribute("data-origin-image");
            let createImage = document.createElement("img");
            createImage.classList.add("pdp__images--hover");
            createImage.src = hoverSrc;
            document.querySelector('.slick-current').classList.add("pdp__images-container--hover");
            document.querySelector('.slick-current').append(createImage);
          }
        });

        item.addEventListener("mouseout", function (e) {
          let currentSlick = document.querySelector('.slick-current');
          if (currentSlick) {
             currentSlick.classList.remove("pdp__images-container--hover");
          }
         
          let allPdpImagesHover = document.querySelectorAll(".pdp__images--hover");
          
          if (allPdpImagesHover.length > 0) {
            for (let k = 0; k < allPdpImagesHover.length;k++) {
              let pdpImagesHover = allPdpImagesHover[k];
              pdpImagesHover.remove();
            }
          }
        });

      }
      
    }
  }
  fetchColorChange() {
    var _this = this;
    $.ajax({
      type: 'GET',
      url: `/search?type=product&q=tag:${this.$productcode}${this.$producttype == SCHMUCK_ART_ID_RINGE ? '*' : '' }&view=json`,
      dataType: 'json'
    }).done(function (res) {
        if (res && res.results && res.results.length) {
          res.results.forEach(function (product) {
            var $template = $(_this.$ajaxColorSwatch.find('template')[0].content.cloneNode(true));
            $template.find('a').attr('href', product.url);
            $template.data().variantId = product.variant.id;
            $template.data().variantSku = product.variant.sku;
            if (product.variant.id == _this.selectedVariantId) {
              $template.find('a').addClass('selected');
              var image;
              $.each(product.media, function (key, value) {
                if (value.src != undefined) {
                  if (value.src.includes('-2_') || value.src.includes('-2.')) {
                    image = value;
                  }  
                }
              });

              if (image) {
                $template.find('img').attr('src', image.src.imgURL('180x180')).attr("data-origin-image", image.src).attr('style',  'max-height:60px');
              } else {
                $template.find('img').attr('src', product.image.thumb).attr("data-origin-image", product.image.thumb);
              }
            } else { 
              $.each(product.media, function (key, value) {
                if (value.src != undefined) {
                  if (value.src.includes('-2_') || value.src.includes('-2.')) {
                    image = value;
                  }  
                }
              });
              if (image) {
                $template.find('img').attr('src', image.src.imgURL('180x180')).attr("data-origin-image", image.src).attr('style',  'max-height:60px');
              } else {
                $template.find('img').attr('src', product.image.thumb).attr("data-origin-image", product.image.thumb);
              }
            }

            _this.$colorSwatch.append($template);
          });

          _this.handleColorHover();

        } else {
          _this.$ajaxColorSwatch.remove();
        }
    });
  }
}

var quicklook = class {

  constructor($quicklook) {
    this.$quicklook = $quicklook;
    this.$ajaxColorSwatch = $quicklook.find('[data-ajax-color-swatch]');
    this.$colorSwatch = this.$quicklook.find('.color-swatch');
    this.$productcode = null;
    if (this.$ajaxColorSwatch.length > 0) {
      this.$productcode = this.$ajaxColorSwatch.data().productcode;
      this.$producttype = this.$ajaxColorSwatch.data().producttype;
    }

    try {
      this.product = JSON.parse($quicklook.find('[data-product-json]').html());
    } catch (error) {
      this.product = null;
    }
    if (this.product) {
      this.selectedVariantId = this.product.variants[0].id;
    }
    if (this.$ajaxColorSwatch.data()) {
      this.$productcode = this.$ajaxColorSwatch.data().productcode;
    }
  }

  init() {
    if (this.product && this.$productcode) {
      this.fetchColorChange();
    } else {
      this.$quicklook.find('.product__selectors').remove();
    }
  }

  fetchColorChange() {
    var _this = this; 
    $.ajax({
      type: 'GET',
      url: `/search?type=product&q=tag:${this.$productcode}${this.$producttype == SCHMUCK_ART_ID_RINGE ? '*' : '' }&view=json`,
      dataType: 'json'
    }).done(function(res) {
      if (res && res.results && res.results.length) {
        
        res.results.forEach(function (product) {
         
            var $template = $(_this.$ajaxColorSwatch.find('template')[0].content.cloneNode(true));
            $template.find('a').attr('href', product.url);
            $template.data().variantId = product.variant.id;
            $template.data().variantSku = product.variant.sku;
            $template.find('img').attr('src', product.image.thumb);
          
            if (product.variant.id == _this.selectedVariantId) {
              $template.find('a').addClass('selected');
              var image;
              $.each(product.media, function (key, value) {
                if (value.src != undefined) {
                  if (value.src.includes('-2_') || value.src.includes('-2.')) {
                    image = value;
                  }
                }
              });

              if (image) {
                $template.find('img').attr('src', image.src.imgURL('180x180')).attr('style', 'max-height:60px');
              } else {
                $template.find('img').attr('src', product.image.thumb);
              }
            } else {

              $.each(product.media, function (key, value) {
                if (value.src != undefined) {
                  if (value.src.includes('-2_') || value.src.includes('-2.')) {
                    image = value;
                  }
                }
              });
              
              if (image) {
                $template.find('img').attr('src', image.src.imgURL('180x180')).attr('style', 'max-height:60px');
              } else {
                 $template.find('img').attr('src', product.image.thumb);
              }
            }
            _this.$colorSwatch.append($template);
          });

        } else {
          _this.$ajaxColorSwatch.remove();
        }
    });
  }
}


$(document).ready(function() {

  $(document).on('click', '.js-trigger-wechat-modal, .js-trigger-rednote-modal', function(e) {
    e.preventDefault();
    theme.modal($(this).data('modal'));
  });

  $('#shopify-section-cart').each(function() {
    var cartPage = new cart($(this));
    cartPage.init();
  });

  $('#shopify-section-product').each(function() {
    var productDetailPage = new pdp($(this));
    productDetailPage.init();
  });

  $('.modal__overlay.quicklook').each(function () {
    
    var quicklookModal = new quicklook($(this));
    quicklookModal.init();
    var $quicklook = $(this);
    var variants = JSON.parse($quicklook.find('[data-product-variants-json]').html());
    var firstVariant = variants[0];
    if (firstVariant.available) {
      $quicklook.find('[data-shipping-status-available]').removeClass('hidden');
      $quicklook.find('[data-shipping-status-unavailable]').addClass('hidden');
      $quicklook.find('[data-add-to-cart]').prop('disabled', false);
      $quicklook.find('[data-add-to-cart-text]').html(theme.strings.addToCart + theme.icons.arrowRight);
    } else {
      $quicklook.find('[data-shipping-status-available]').addClass('hidden');
      $quicklook.find('[data-shipping-status-unavailable]').removeClass('hidden');
      $quicklook.find('[data-add-to-cart]').prop('disabled', true);
      $quicklook.find('[data-add-to-cart-text]').html(theme.strings.soldOut + theme.icons.arrowRight);
    }

    var imageGallery = {
      init: function() {
        this.init = this.init.bind(this);
        this.initGalleryMain = this.initGalleryMain.bind(this);
        this.initGalleryThumbs = this.initGalleryThumbs.bind(this);
        this.update = this.update.bind(this);
        this.emptySlides = this.emptySlides.bind(this);
        this.appendSlides = this.appendSlides.bind(this);
        this.variantChange = this.variantChange.bind(this);
        this.initGalleryThumbs();
        this.initGalleryMain();
        try {
          this.product = JSON.parse($quicklook.find('[data-product-json]').html());
          this.galleryJSON = JSON.parse($quicklook.find('[data-product-gallery-json]').html());
          this.currentVariantId = this.product.variants[0].id;
          this.currentVariantSku = this.product.variants[0].sku;
        } catch (error) {
          console.log(error);
        }
        if (this.galleryJSON && this.galleryJSON.length) {
          this.appendSlides();
        }
      },
      initGalleryMain: function() {
        
        this.galleryMain = new Swiper($quicklook.find('.swiper-container.gallery-main')[0], {
          direction: 'horizontal',
          loop: false,
          autoplay: false,
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          freeMode: false,
          preloadImages: false,
          lazy: true,
          thumbs: {
            swiper: this.galleryThumbs
          }
        });
      },
      initGalleryThumbs: function() {
        this.galleryThumbs = new Swiper($quicklook.find('.gallery-thumbs')[0], {
          direction: 'horizontal',
          loop: false,
          autoplay: false,
          slidesPerView: 5,
          slidesPerGroup: 1,
          freeMode: false,
          spaceBetween: 10,
          direction: 'horizontal',
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          allowTouchMove: false,
          preloadImages: false,
          lazy: true
        });
      },
      update: function() {
        if (this.galleryMain) {
          this.galleryMain.update();
        }
        if (this.galleryThumbs) {
          this.galleryThumbs.slideReset();
          this.galleryThumbs.update();
        }
      },
      emptySlides: function() {
        if (this.galleryMain) {
          this.galleryMain.removeAllSlides();
        }
        if (this.galleryThumbs) {
          this.galleryThumbs.removeAllSlides();
        }
      },
      appendSlides: function() {
        var _this = this, imageSlides;
        if (this.galleryMain && this.galleryThumbs) {
          imageSlides = this.galleryJSON.filter(function(image) {
            return image.filename.includes(_this.currentVariantSku);
          });
          if (imageSlides && imageSlides.length) {
            imageSlides.forEach(function(imageSlide, i) {
              var active = '';
              if (i == 0) {
                active = 'swiper-slide-thumb-active';
              }
              var is_image_2 = false;
              if (imageSlide.thumb.includes('-2_') || imageSlide.thumb.includes('-2.')) {
                is_image_2 = true;
              }
              if (!is_image_2) {
                _this.galleryThumbs.appendSlide('<div class="swiper-slide ' + active + '"><img class="swiper-lazy" style="width: 100%; height: auto;" data-src="' + imageSlide.thumb + '"><div class="swiper-lazy-preloader"></div></div>');
              }
              _this.galleryMain.appendSlide('<div class="swiper-slide"><img class="swiper-lazy" style="width: 100%; height: auto;" data-src="' + imageSlide.img + '"><div class="swiper-lazy-preloader"></div></div>');
            });
          }
        }
      },
      variantChange: function(variantId, variantSku) {
        this.currentVariantId = variantId;
        this.currentVariantSku = variantSku;
        this.emptySlides();
        this.appendSlides();
      }
    }

    imageGallery.init();

    $(document).on('click', '.trigger-quick-view', function(e) {
      e.preventDefault();
      imageGallery.update();
    });

    $quicklook.find('.color-swatch .thumb--image').each(function() {
      $(this).click(function(e) {
        e.preventDefault();
        if (!$(this).is('.selected')) {
          var variantId = $(this).data().variantId;
          var variantSku = $(this).data().variantSku;
          var currentVariant = JSON.parse($quicklook.find('[data-product-variants-json]').html());
          currentVariant = currentVariant.find(function(variant) {
            return variant.id == variantId;
          });
          $quicklook.find('.product-sku').html(variantSku);
          imageGallery.variantChange(variantId, variantSku);
          $('.color-swatch .thumb--image.selected').removeClass('selected');
          $(this).addClass('selected');
          if (currentVariant.available) {
            $quicklook.find('[data-shipping-status-available]').removeClass('hidden');
            $quicklook.find('[data-shipping-status-unavailable]').addClass('hidden');
            $quicklook.find('[data-add-to-cart]').prop('disabled', false);
            $quicklook.find('[data-add-to-cart-text]').html(theme.strings.addToCart + theme.icons.arrowRight);
          } else {
            $quicklook.find('[data-shipping-status-available]').addClass('hidden');
            $quicklook.find('[data-shipping-status-unavailable]').removeClass('hidden');
            $quicklook.find('[data-add-to-cart]').prop('disabled', true);
            $quicklook.find('[data-add-to-cart-text]').html(theme.strings.soldOut + theme.icons.arrowRight);
          }
        }
      });
    });
  });
  if ($('body.template-product').length) {

    var ring_variants = [];
    var ringVariantId_size_56 = 0;
    function handleVariantIDRing() {

      var productHandleSetCode = window.product_handle_set_code;
      var counter = 0;
      var setProductCount = productHandleSetCode.length;
      productHandleSetCode.forEach(function (value, key) {
        var product_url = window.location.origin + "/products/" + value + ".json";
        fetch(product_url)
          .then((response) => {
            return response.json()
          })
          .then((data) => {

            if (data.product.product_type == "Ring" && data.product.variants && data.product.variants.length > 0) {
              var is_finish = false;
              ring_variants = data.product.variants.reverse();
              var has_ring_self = false;
              if (window.ring_variants_id_setcode) {
                ring_variants.forEach(function (ringVariantItem, key) {
                  if (ringVariantItem.id == window.ring_variants_id_setcode) {
                    has_ring_self = true;
                  }
                });
              }
              if (has_ring_self == false) {
                ring_variants.forEach(function (variants_value, key) {
                  if (parseInt(variants_value.title) == 56 && !is_finish) {
                    ringVariantId_size_56 = variants_value.id;
                    is_finish = true;
                  }
                  if (parseInt(variants_value.title) < 56 && !is_finish) {
                      ringVariantId_size_56 = variants_value.id;
                      is_finish = true;
                  }
                });
              }
            }
            counter++;
            if (counter == setProductCount) {
              handleVariantIDSetCode();
            }
          })
          .catch((err) => {
            // Do something for an error here
            counter++;
            if (counter == setProductCount) {
              handleVariantIDSetCode();
            }
          });

      });
    }

    function handleVariantIDSetCode() {
      
      var variants = $('[data-add-set-to-cart]').data().variants;
      var data = {
        items: []
      };
      variants.forEach(function (variantId) {

        if (ringVariantId_size_56 != 0) {
          ring_variants.forEach(function (variantValueRing, key) {
            if (variantValueRing.id == variantId) {
              variantId = ringVariantId_size_56;
            }
          });
        }
       
        data.items.push({
          quantity: 1,
          id: variantId
        });
      });
      addToCartSetCode(data);
    }

    function addToCartSetCode(data) {

        var addToCartFail = function(obj) {
        var errors = '', popoverTimer, 
            $popover = $('#CartPopoverCont');

        $popover.empty();
        errors += '<div class="errors">' + obj.responseJSON.message + ': '+ obj.responseJSON.description + '<span class="close"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg></span></div>';
        $popover.append( errors );
        $popover.addClass('is-visible').addClass('contains-errors');
        clearTimeout(popoverTimer);
        popoverTimer = setTimeout(function(){
          $popover.removeClass('is-visible').removeClass('contains-errors');
        }, 6000);
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data
      }).done(function(products) {
       // console.log({products});
        showCartNotificationPopup(products.items);
      }).fail(function(xhr, status, error) {
        if (xhr && xhr.responseJSON && xhr.responseJSON.message) {
          addToCartFail(xhr);
        }
      });
    }

    
    $('body.template-product').find('[data-add-set-to-cart]').click(function(e) {
      e.preventDefault();
      handleVariantIDRing();
    });

    var hideCartNotificationPopup = function($popover) {
      $popover.removeClass( 'is-visible' ).removeClass( 'contains-errors' );
    }

    var showCartNotificationPopupSet = function(products, product, index) {
      // console.log($('#CartPopoverSet').html(), '######')
      var addedQuantity = parseInt( $('.quantity__input', this.$container).val() );
      var $popover = $('#CartPopoverCont'),
      popoverTimer,
      item = {},
      source = $('#CartPopoverSet').html(),
      template = Handlebars.compile(source),  
      timeout = 6000; // milliseconds
      item = {
        products: products,
        products_size: products.length,
        item_count: addedQuantity,
        image: product.image,
        product_title: function(){
          return product.product_title.length > 50 ? product.product_title.substring(0, 50) + '...' : product.product_title;
        },
        variant: product.variant_title == 'Default Title' ? false : product.variant_title,
        price: product.price,
        price_formatted: slate.Currency.formatMoney(product.price, theme.moneyFormat)
      }
      //INFO EDITED BY LATORI price_formatted: slate.Currency.formatMoney(product.price, theme.moneyFormat)

      $popover.empty().append(template(item));

      // clear popover timer, set at top of Cart object
      clearTimeout(timeout);
      let extraHeight = 4;
      // Popover should be just below header
      var top =  $('.header__content').outerHeight()
      $popover.attr('style','');

      // If it is sticky, just put it at the header height with position: fixed
      if ( $('#header').hasClass('header--sticky') ) {
        $popover.css( 'top', top + extraHeight );
      } else if ( $(window).scrollTop() > top ){
        // header is not visible pin to top
        $popover.css( 'top', extraHeight );
        $popover.css( 'z-index', '2000' );
      }
      else {
      // otherwise positon: absolute below header
      // or at top if scrolled below header
        let isPromoBar = $('aside.usp-bar.action-bar'); // edited by latori GmbH to add extra space from top and adding the height of action-bar
          if (isPromoBar.length > 0){
            if (isPromoBar.position().top == 0){
              extraHeight = (2 * extraHeight) + isPromoBar.outerHeight()
            }
          }
        top = Math.max( $(window).scrollTop() , top) + extraHeight;
        $popover.css( 'position', 'absolute' );
        $popover.css( 'top', top );
      }

      $popover.addClass( 'is-visible' ).removeClass( 'contains-errors');

      // set new instace of popoverTimer
      popoverTimer = setTimeout(function(){
        hideCartNotificationPopup($popover);
      }, timeout);

    }

    var showCartNotificationPopup = function(products){
      for (let index = 0; index < products.length; index++) {
        var product = products[index];
        showCartNotificationPopupSet(products, product, index)
      }
    }

    $('#more-set-products').each(function () {

      var $section = $(this);
      var slidesLength = $section.find('.swiper-wrapper').children().length;

      var checkSwiperState = function($this, swiper, slidesLength) {
        var windowWidth = $(window).width();
        /*
        if (slidesLength <= 3) {
          if ($(window).width() < 768 && swiper.initialized && !swiper.allowTouchMove) {
              swiper.allowTouchMove = true;
              swiper.params.allowTouchMove = true;
              swiper.loop = true;
              swiper.params.loop = true;
              $this.find('.swiper-btn-prev').show();
              $this.find('.swiper-btn-next').show();
              swiper.navigation.update();
              swiper.update();
          }
          if ($(window).width() >= 768 && swiper.initialized && swiper.allowTouchMove) {
              swiper.allowTouchMove = false;
              swiper.params.allowTouchMove = false;
              swiper.loop = false;
              swiper.params.loop = false;
              swiper.navigation.update();
              swiper.update();
          }
        }
        */

        if (windowWidth >= 1024 && slidesLength <= 3) {
            swiper.allowTouchMove = false;
            swiper.params.allowTouchMove = false;
            $this.find('.swiper-btn-prev').hide();
            $this.find('.swiper-btn-next').hide();
            // this.$swiperRoot.removeClass('active');
        } else if (windowWidth < 1024 && slidesLength < 3) {
            swiper.allowTouchMove = true;
            swiper.params.allowTouchMove = true;
            $this.find('.swiper-btn-prev').show();
            $this.find('.swiper-btn-next').show();
            // this.$swiperRoot.removeClass('active');
        } else if (windowWidth <= 480 && slidesLength < 2) {
            swiper.allowTouchMove = false;
            swiper.params.allowTouchMove = false;
            $this.find('.swiper-btn-prev').hide();
            $this.find('.swiper-btn-next').hide();
            // this.$swiperRoot.removeClass('active');
        } else {
            swiper.allowTouchMove = true;
            swiper.params.allowTouchMove = true;
            $this.find('.swiper-btn-prev').show();
            $this.find('.swiper-btn-next').show();
            swiper.slideTo(0);
            // if (!this.$swiperRoot.hasClass('active')) {
            //     swiper.slideTo(0);
            //     this.$swiperRoot.addClass('active');
            // }
        }
        swiper.navigation.update();
        swiper.update();
      }

      var mySwiper = new Swiper($section.find('.swiper-container')[0], {
        direction: 'horizontal',
        loop: false,
        allowTouchMove: slidesLength > 4 ? true : false,
        autoplay: false,
        watchSlidesVisibility: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        preloadImages: false,
        updateOnImagesReady: true,
        lazy: true,
        spaceBetween: 20,
        freeMode: false,
        init: false,
        pagination: false,
        navigation: {
          nextEl: '.swiper-btn-next-set',
          prevEl: '.swiper-btn-prev-set',
        },
        breakpoints: {
          1024: {
            slidesPerView: 4
          },
          768: {
            slidesPerView: 3
          },
          480: {
            slidesPerView: 2.5
          },
          1: {
            slidesPerView: 2.5
          }
        },
        on: {
            lazyImageReady: function() {
                this.updateAutoHeight();
            },
            resize: function() {
                checkSwiperState($section, this, slidesLength);
            }
        }
      });
      mySwiper.init();
      checkSwiperState($section, mySwiper, slidesLength);

    });

    
    $('#recommendations-products').each(function() {

      var recommendationsProductsSlider = class {
        
        constructor($section) {
          this.$section = $section;
          try {
            this.product = JSON.parse($('[data-product-json]').html());
            this.variantId = this.product.variants[0].id;
          } catch (error) {
            this.product = null;
            this.variantId = null;
          }
          this.color = $section.data().color;
        }

        init() {
            this.initSlider();
            this.loadProducts();
        }

        removeSection() {
          this.$section.empty();
        }

        loadProducts() {
            var _this = this;
            $.get('/collections/all/'+this.color+'?view=json')
              .done(function(res) {
                // try {
                  res = JSON.parse(res);
                  if (res && res.results && res.results.length) {
                    _this.products = res.results;
                    _this.replaceSlides();
                  } else {
                    // throw 'Error';
                  }
                // } catch (err) {
                //   _this.removeSection();
                // }
              })
              .fail(function() {
                _this.removeSection();
              });
        }

        replaceSlides() {
          var _this = this;
          this.products.forEach(function(product, index) {
            if (_this.variantId && _this.variantId == product.variants[0].id) {
              return;
            }
            
            let productImage = product.image.replace("1024x1024", "720x720");
            var $slide = _this.$section.find('.swiper-slide[data-replace-index="'+index+'"]');
            var $product =  $('<a href="/products/'+product.handle+'">' +
                                  '<figure>' +
                                    '<img src="'+productImage+'">' +
                                  '</figure>' +
                                '</a>');
            $slide.empty();
            $slide.append($product);
            $slide.removeClass('init');
          });
          this.$section.find('.swiper-slide.init').remove();
          this.$swiper.navigation.update();
          this.$swiper.update();
        }

        initSlider() {
          var _this = this;
          this.$swpr_root = this.$section.find('.swiper');
          this.$swpr_container = this.$section.find('.swiper-container');
          this.$swpr_wrapper = this.$section.find('.swiper-wrapper');
          this.$swpr_pagination = this.$section.find('.swiper-pagination');
          this.$swpr_slides = this.$section.find('.swiper-slide');
          this.$swpr_prevEl = this.$section.find('.swiper-btn-prev');
          this.$swpr_nextEl = this.$section.find('.swiper-btn-next');
          this.$swiper = new Swiper(this.$swpr_container[0], {
              loop: false,
              allowTouchMove: true,
              autoplay: false,
              watchSlidesVisibility: true,
              slidesPerView: 4,
              slidesPerGroup: 1,
              preloadImages: false,
              updateOnImagesReady: true,
              lazy: true,
              spaceBetween: 20,
              direction: 'horizontal',
              autoHeight: true,
              freeMode: false,
              init: false,
              navigation: {
                  nextEl: this.$swpr_nextEl[0],
                  prevEl: this.$swpr_prevEl[0]
              },
              breakpoints: {
                1024: {
                  slidesPerView: 4
                },
                768: {
                  slidesPerView: 3
                },
                480: {
                  slidesPerView: 2.5
                },
                1: {
                  slidesPerView: 2.5
                }
              },
              on: {
                  lazyImageReady: function() {
                      this.updateAutoHeight();
                  },
                  resize: function() {
                      if (_this.products.length <= 3) {
                          if ($(window).width() < 768 && this.initialized && !this.allowTouchMove) {
                              this.allowTouchMove = true;
                              this.params.allowTouchMove = true;
                              this.loop = true;
                              this.params.loop = true;
                              if (_this.$swpr_pagination && _this.$swpr_pagination.length) {
                                  _this.$swpr_pagination.show();
                              }
                              this.navigation.update();
                              this.update();
                          }
                          if ($(window).width() >= 768 && this.initialized && this.allowTouchMove) {
                              this.allowTouchMove = false;
                              this.params.allowTouchMove = false;
                              this.loop = false;
                              this.params.loop = false;
                              if (_this.$swpr_pagination && _this.$swpr_pagination.length) {
                                  _this.$swpr_pagination.hide();
                              }
                              this.navigation.update();
                              this.update();
                          }
                      }
                  }
              }
          });
          this.$swiper.init();
        }
      }

      var xs = new recommendationsProductsSlider($(this));
      xs.init();

    });

  }

  //Make Nav children bold on hover
  $('.site-nav.nav__links .parent').hover(function() {
    $(this).find('.dropdown-item a.nav-link').addClass( "bold" );
  }, function() {
    $(this).find('.dropdown-item a.nav-link').removeClass( "bold" );
  });

  //Make highest level Nav links underlined on meganav hover
  $('.main-menu-dropdown').hover(function() {
    $(this).parent('.grandparent').children('.dropdown-item').children('a.nav-link').addClass('nav-link-underline');
  }, function() {
    $(this).parent('.grandparent').children('.dropdown-item').children('a.nav-link').removeClass('nav-link-underline');
  });

   $('.search-desktop .search-query').click(function() {
     $(".search-desktop").addClass("search--open");
  });

  /**
   * hover/touchstart for Mobile
   * 
   * @param {jQuery} $element 
   * @param {string} hoverClass 
   */
  // function hoverMobileElement($element, hoverClass) {

  //   $element.on('touchstart', function (e) {
  //     'use strict'; 
  //     var link = $(this);
  //     if (link.hasClass(hoverClass)) {
  //         return true;
  //     } else {
  //         link.addClass(hoverClass);
  //         $element.not(this).removeClass(hoverClass);
  //         e.preventDefault();
  //         return false; //extra, and to make sure the function has consistent return points
  //     }
  //   });
  // }
  // //featured-product-slider-section
  // hoverMobileElement($('.featured-product-slider-section .product-link'), "touch-product-link");
  //  //featured-product-slider-section
  // hoverMobileElement($('.collection__products .product-link'), "touch-product-link");

});